<template>
			<div style="overflow: hidden;" v-if="current.indexOf('首页') > -1">
				<div class="bannerBox">
					<a-carousel :dot="bottom" autoplay>
						<div  class="bannerImg" v-for="(item, index) in bannerData" :key="index">
							<img :src="getImg(item.imageUrl)" />
						</div>
					</a-carousel>
				</div>
				<div class="scjrProductBox">
					<div class="scjrProductTitleBox">
						<div class="scjrProductTitle">
							金融产品
						</div>
						<div class="hotBox">
							<div class="hotContent">信用贷款全部产品</div>
						</div>
						<div @click="goMore('/finance/financialProduct','金融产品')" class="MoreBox">更多</div>
					</div>
					<div class="scjrProductContentBox">
						<div class="scjrProductSmallBox" v-for="(item, index) in productData" :key="index" @click="goMore('/finance/product/page','金融产品',item.id)">
							<div class="scjrProductSmallLeft">
								<img v-if="item.img" :src="getImg(item.img)" alt="">
								<img v-else src="@/assets/img/defaultPhoto.png" alt="">
							</div>
							<div class="scjrProductSmallRight">
								<div class="scjrProductSmallRightItemLeft" style="width:85%">
									<div class="scjrProductSmallRightItemLeftTop">
										{{ item.productName }}<span v-if="item.remark">· </span> {{item.remark}}
									</div>
									<div class="scjrProductSmallRightItemLeftDown">
										<p>所属银行：<span>
                                            {{item.institutionsName}}
											<!-- <dict-render :dict-obj="dictObjs['guarantee']"
											:text="item.guarantyType"></dict-render> -->
                                        </span>
                                        </p>
										<p>产品介绍：{{ item.details }}</p>
									</div>
								</div>
								<div class="scjrProductSmallRightItemRight">
									<a-button style="margin-top: 18px;" >查看详情</a-button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div style="width: 100%;background-color: #fff;">
					<div class="tzrBox">
						<div class="tzrTitleBox">
							<div class="tzrTitle">
								投资人
							</div>
							<div @click="goMore('/finance/investor','投资人')" class="MoreBox">更多</div>
						</div>
						<div class="tzrContent">
							<div class="tzrItem" v-for="item in InvestorData" @click="goMore('/finance/investor/page','投资人',item.id)" :key="item.key">
								<div class="tzrItemLeft">
									<div class="tzrItemLeftImg">
										<img v-if="item.headImg" :src="getImg(item.headImg)" alt="">
										<img v-else src="@/assets/img/userPhoto.jpg" alt="">
									</div>
								</div>
								<div class="tzrItemRight">
									<div class="tzrItemContentBox">
										<div class="tzrItemContentName">{{ item.investorName }} <span style="font-size: 14px;color: #666"> · <dict-render :dict-obj="dictObjs[']"
											:text="item"></dict-render></span></div>
										<div class="tzrItemContentLing">投资领域：
											<dict-render :dict-obj="dictObjs[']"
											:text="item.></dict-render></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div> -->
				<div style="width: 100%;background-color: #fff;">
					<div class="activityBox">
						<div class="activityTitleBox">
							<div class="activityTitle">
								金融机构
							</div>
							<div class="hotBox">
								<div class="hotContent">可进行联系对接</div>
							</div>
							<div @click="goMore('/finance/invertorInstitution','金融机构')" class="MoreBox">更多</div>
						</div>
						<div class="activityContent">
							<div class="activityLi" v-for="item in MechanisData" @click="goMore('/finance/institution/page','金融机构',item.id)" :key="item.key">
								<div class="activityImg">
									<img v-if="item.logo" :src="getImg(item.logo)" alt="">
									<img v-else src="@/assets/img/defaultPhoto.png" alt="">
								</div>
								<div class="activityInfoTitle">
									{{ item.institutionsName }}
								</div>
								<div class="activityInfoTime">
									{{ item.briefIntroduction }}
								</div>
								<div class="activityInfoAddress">
									<div class="leftLogo">
										<img src="@/assets/img/tzjg.png" alt="">
									</div>
									<div style="float: left;margin-left: 10px; width:200px
									text-overflow:ellipsis; white-space:nowrap; overflow:hidden;
									">
									联系电话：{{item.contactNumber}}
									<!-- <dict-render :dict-obj="dictObjs[']"
									:text="item.></dict-render> -->
								</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div>
					<div class="scjrNewsBox">
						<div class="scjrNewsLeftBox">
							<div class="scjrNewsTitleBox">
								<div class="scjrNewsTitle">
									金融资讯
								</div>
								<div class="hotBox">
									<div class="hotContent">实时金融新闻资讯</div>
								</div>
								<div class="MoreBox">更多 ></div>
							</div>
							<div class="scjrNewsContentBox">
								<div class="scjrNewsSmallBox">
									<div class="scjrNewsSmallTop">
										<div class="avtar">
											<img :src="newsData[0].newsPic" alt="">
										</div>
										<div class="newsInfo">
											<div class="newsName">{{ newsData[0].newsName }}</div>
											<div class="newsIntroduce">{{ newsData[0].newsInfo }}</div>
											<div class="newsTime">{{ newsData[0].newsTime }}</div>
										</div>
									</div>
									<div class="scjrNewsSmallBottom">
										<div class="scjrNewsSmallItem" v-for="(item, index) in newsData" :key="index">
											<div class="itemTitle">{{ item.newsName }}</div>
											<div class="itemTime">{{ item.newsTime }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="scjrNewsRightBox">
							<div class="scjrNewsTitleBox">
								<div class="scjrNewsTitle">
									法律法规
								</div>
								<div class="hotBox">
									<div class="hotContent">认识并了解法律知识</div>
								</div>
								<div class="MoreBox">更多 ></div>
							</div>
							<div class="scjrNewsContentBox">
								<div class="scjrNewsPic">
									<img src="@/assets/img/scjrflfg.png" alt="">
								</div>
								<div class="scjrNewsSmallBox" v-for="(item, index) in laywerData?.slice(0, 3)" :key="index">
									<div class="teacherName">
										{{ item.teacherName }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div> -->
			</div>
</template>

<script>
import { platformName } from "@/config/platformConfig";
import {financeProductWeb,financeMechanismWeb,financeInvestorWeb} from "@/api/finance";
import { dictMixin } from "@/mixins";
// import DictRender from "@/components/other/DictRender";
import {file_service} from "@/api/adminService";
import { getBannerInfo } from "@/api/homeService";

export default {
	name: "index",
	// components: {
	// 	DictRender
	// },
  mixins: [dictMixin],
	data() {
		return {
      role: null,
      dictNames: 'guarantee',
			platformName,
			InvestorData:[],
			MechanisData:[],
			productData:[],
			current: ['首页'],
			clickMenuTitle: '',
			formState: {
				user: null,
			},
			formSearchBox: {
				city: null,
				company: null,
				project: null,
				demand: null
			},
			bannerData:[],
		}
	},
	mounted(){
		this.getBannerList()
		this.getSerchData()
		if(this.$ls.get('roleCode')){
        this.role = this.$ls.get('roleCode').replace("[","").replace("]","").replace("\"","").replace("\"","").replace("\"","").replace("\"","").split(',')
				this.role.map( item => {
          if(item=='company'){
          this.role = item
          }
        })
		}

	},
	methods: {
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		getSerchData(){
      this.getAction({
					url: financeProductWeb.list,
					params: {
						limit:4
					},
			}).then(res => {
				this.productData = res
			})
			this.getAction({
					url: financeMechanismWeb.list,
					params: {
						limit:4
					},
			}).then(res => {
				this.MechanisData = res
			})
			this.getAction({
					url: financeInvestorWeb.list,
					params: {
						limit:4
					},
			}).then(res => {
				this.InvestorData = res
			})
    },
		goMore(url,key,id) {
      this.$router.push({
				path: url,
				query: { type: key,queryData: id }
			})
		},
		menuClick(e) {
			this.clickMenuTitle = e.item.title
		},
		backhome() {
			this.$router.push('/')
		},
		getBannerList() {
			this.getAction({
				url: getBannerInfo.pageList,
				params: { type: 'finance' }
			}).then(res => {
				this.bannerData = res.records.reverse()
			})
		},
	}
}
</script>

<style scoped lang="less">
@import "../css/main.less";
:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after){
	border-bottom: 3px solid #1890ff
}
:deep(.ant-menu-item-selected){
	font-weight: 600;
}
:deep(.ant-btn){
	border-radius: 0;
}

</style>
